var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDrop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 7V9.0884L9.9116 10H10.0811L11 9.08105V7H9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 16.5856V12.6566L5.65655 11H14.5859L16 12.4141V16.8281L14.8281 18H5.41436L4 16.5856ZM14 13H6V16H14V13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4998 8L20 6.06553C19.8765 5.68205 19.7161 5.30532 19.5198 4.93853C19.0002 3.96793 18.2386 3.08601 17.2785 2.34315C16.3184 1.60028 15.1786 1.011 13.9241 0.608964C12.6697 0.206926 11.3252 0 9.96743 0C8.60964 0 7.26514 0.206926 6.01071 0.608964C4.75627 1.011 3.61646 1.60028 2.65636 2.34315C1.69626 3.08601 0.934664 3.96793 0.41506 4.93853C0.25159 5.24389 0.113078 5.55615 0 5.87345L2.74841 8L7.38258 8L4.79772 6H2.58053C2.62881 5.89325 2.681 5.78745 2.73707 5.68272C3.13036 4.94805 3.70683 4.28051 4.43355 3.71822C5.16027 3.15593 6.02301 2.7099 6.97251 2.40559C7.92202 2.10128 8.93969 1.94465 9.96743 1.94465C10.9952 1.94465 12.0128 2.10128 12.9623 2.40559C13.9118 2.7099 14.7746 3.15593 15.5013 3.71822C16.228 4.28051 16.8045 4.94805 17.1978 5.68272C17.2539 5.78745 17.306 5.89325 17.3543 6H15.1371L12.5523 8H17.4998Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrop);
export default __webpack_public_path__ + "static/media/icon-drop.11f93fd2.svg";
export { ForwardRef as ReactComponent };